import Box from '@mui/material/Box';
import { styled } from '@mui/material';

import { zIndex, devices } from 'styles';

export const HeaderStyled = styled(Box)`
  top: 0;
  z-index: ${zIndex.header};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: fixed;
  padding: 20px 0;

  transition-property: padding, background, border;
  transition-duration: 0.5s;
`;

export const HeaderNavigation = styled(Box)`
  width: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;

  @media (${devices.lg}) {
    padding: 0 40px;
  }
`;
